import tw from "twin.macro";

export const Container = tw.div`relative`;
export const ContentWithPaddingXl = tw.div`max-w-screen-xl mx-auto py-6 lg:py-20`;
export const ContentWithPaddingLg = tw.div`max-w-screen-lg mx-auto py-6 lg:py-20`;
export const ContentWithVerticalPadding = tw.div`py-20 lg:py-24`;
export const Content2Xl = tw.div`max-w-screen-2xl mx-auto`;
